import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import $ from 'jquery';
import { Component } from '@mycolorway/tao';

Component('tr-import-header-match-form', {
  mixins: [eventListenerMixin],

  ready() {
    this.submitBtn = document.querySelector('#confirm-btn');
    this.hiddenRealSubmitBtn = this.querySelector('input[type=submit]');
    this.trForm = this.querySelector('.tr-form');
    this.listenTo(this.submitBtn, 'click', () => {
      this.hiddenRealSubmitBtn.click();
    });

    $(this.trForm).on('ajax:beforeSend', () => {
      this.submitBtn.setAttribute('disabled', true);
    });
    $(this.trForm).on('ajax:complete', () => {
      this.submitBtn.setAttribute('disabled', false);
    });
  },

  disconnected() {
    this.stopListening();
  },
});
